import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import { ICreator } from '@/interfaces';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
  <TableHeader>
    <TableRow>
      <TableHead />
      <TableHeadSortable
        className='pe-0'
        name={nameof<ICreator>('gender')}
        text='Genre' />
      <TableHead className='pe-0'>
        Type
      </TableHead>
      <TableHeadSortable
        className='text-right pe-0'
        name={nameof<ICreator>('referralCount')}
        text='Parrainé(s)' />
      <TableHead className='pe-0'>
        Nom
      </TableHead>
      <TableHead className='pe-0'>
        Code promo
      </TableHead>
      <TableHead className='pe-0'>
        Pièces
      </TableHead>
      <TableHead className='pe-0'>
        Liens
      </TableHead>
      <TableHeadSortable
        className='pe-0'
        name={'extra.paymentInfo.method'}
        text='Méthode' />
      <TableHead className='pe-0'>
        Détails
      </TableHead>
      <TableHeadSortable
        className='text-right pe-0'
        name={nameof<ICreator>('createdAt')}
        text='Crée le' />
      <TableHead />
    </TableRow>
  </TableHeader>
);

export default DataTableHeader;
